import { NgModule } from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import { TaxSummaryOverviewComponent } from './tax-summary-overview/tax-summary-overview.component';

@NgModule({
  declarations: [
    TaxSummaryOverviewComponent,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    TaxSummaryOverviewComponent,
  ],
})
export class TaxSummaryModule { }
